export class Focus {
  xpos: number;
  ypos: number;
}
